import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  showArrow?: boolean;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  showArrow = true,
  fullWidth = false,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const classes = `
    inline-flex items-center justify-center gap-2 
    bg-[#C75C3A] hover:bg-[#b04f30] text-white 
    font-medium text-lg px-8 py-4 rounded-full 
    transition-all duration-300 ease-in-out
    shadow-[0_4px_14px_0_rgba(199,92,58,0.39)]
    hover:shadow-[0_6px_20px_rgba(199,92,58,0.23)]
    hover:-translate-y-0.5
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} onClick={onClick as any} data-id="element-196">
        {children}
        {showArrow && <ArrowRight className="w-5 h-5" data-id="element-197" />}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-198">
      {children}
      {showArrow && <ArrowRight className="w-5 h-5" data-id="element-199" />}
    </button>;
}